import { useTheme } from "@mui/material";
import { useEffect, useState } from "react";

function useWindowSize() {
  const theme = useTheme();
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
    value: undefined,
  });

  useEffect(() => {
    const getValue = (width) => {
      if (width < theme.breakpoints.values.xs) {
        return 'xs';
      }
      if (width < theme.breakpoints.values.sm) {
        return 'sm';
      }
      if (width < theme.breakpoints.values.md) {
        return 'md';
      }
      if (width < theme.breakpoints.values.lg) {
        return 'lg';
      }
      if (width < theme.breakpoints.values.xl) {
        return 'xl';
      }
      return 'xxl';
    };

    // Handler to call on window resize
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        value: getValue(window.innerWidth),
      });
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, [theme]);

  return windowSize;
}

export default useWindowSize;